import { adminServerInstance, driverServerInstance, appMainServerInstance, deliveryServerInstance } from "../axios/instances";
import { 
    GET_LETIAN_STAFF,
    GET_LETIAN_STAFF_SUCCESS,
    GET_LETIAN_STAFF_FAIL,
    GET_DRIVER_DISPATCH_BETWEEN,
    GET_DRIVER_DISPATCH_BETWEEN_SUCCESS,
    GET_DRIVER_DISPATCH_BETWEEN_FAIL,
    GET_DRIVER_DISPATCH_BY_ID,
    GET_DRIVER_DISPATCH_BY_ID_SUCCESS,
    GET_DRIVER_DISPATCH_BY_ID_FAIL,
    QUICK_TRANSFER_ORDERS,
    QUICK_TRANSFER_ORDERS_SUCCESS,
    QUICK_TRANSFER_ORDERS_FAIL,
    GET_DRIVER_DROPOFF_HISTORY,
    GET_DRIVER_DROPOFF_HISTORY_SUCCESS,
    GET_DRIVER_DROPOFF_HISTORY_FAIL,
    GET_DISPATCH_LIST_HISTORY,
    GET_DISPATCH_LIST_HISTORY_SUCCESS,
    GET_DISPATCH_LIST_HISTORY_FAIL,
    GET_ORDERS_BY_DRIVER_CRITERIA,
    GET_ORDERS_BY_DRIVER_CRITERIA_SUCCESS,
    GET_ORDERS_BY_DRIVER_CRITERIA_FAIL,
    UPDATE_DISPATCH_SUMMARY,
    UPDATE_DISPATCH_SUMMARY_SUCCESS,
    UPDATE_DISPATCH_SUMMARY_FAIL,
    GET_SCAN_BATCH_REPORTS,
    GET_SCAN_BATCH_REPORTS_SUCCESS,
    GET_SCAN_BATCH_REPORTS_FAIL,
    SET_SCAN_BATCH_STATUS,
    SET_SCAN_BATCH_STATUS_SUCCESS,
    SET_SCAN_BATCH_STATUS_FAIL,
    HANDLE_DRIVER_ID_DISPATCH,
    UPDATE_SCAN_STATUS,
    UPDATE_SCAN_STATUS_SUCCESS,
    UPDATE_SCAN_STATUS_FAIL,
    HANDLE_RETURN_SCAN,
    HANDLE_RETURN_SCAN_SUCCESS,
    HANDLE_RETURN_SCAN_FAIL
} from './types';

export function handleReturnScan(batchId, tno, operator) {
    return function (dispatch) {
        dispatch({ type: HANDLE_RETURN_SCAN })
        return deliveryServerInstance.put(`/delivery/parcels/scanned/${batchId}/${tno}`, {
            action: "RETURNED",
            operator: operator
        })
            .then(({ data }) => {
                dispatch({
                    type: HANDLE_RETURN_SCAN_SUCCESS,
                    payload: data.biz_data
                })
                return Promise.resolve(data.biz_data);
            }).catch(error => {
                dispatch({
                    type: HANDLE_RETURN_SCAN_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.tracking_no - Tracking NO.
 * @param {string} params.scan_batch_id - Scan batch ID
 */
export function updateScanStatus(params) {   
    return function(dispatch) {
        dispatch({type: UPDATE_SCAN_STATUS})
        return deliveryServerInstance.post(`/delivery/ext/scan`, params)
        .then(({data}) => {
            dispatch({
                type: UPDATE_SCAN_STATUS_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: UPDATE_SCAN_STATUS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function handleDriverIdSearch(driverId) {
    return function(dispatch){
    dispatch({type: HANDLE_DRIVER_ID_DISPATCH})
    return (
        dispatch({
            type: HANDLE_DRIVER_ID_DISPATCH,
            payload: driverId
        })
    )}
}

export function setScanBatchStatus(scanBatchId, status) {   
    return function(dispatch) {
        dispatch({type: SET_SCAN_BATCH_STATUS})
        return deliveryServerInstance.put(`/delivery/ext/scan/batch/${scanBatchId}`, {
            status: status
        })
        .then(({data}) => {
            dispatch({
                type: SET_SCAN_BATCH_STATUS_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: SET_SCAN_BATCH_STATUS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.warehouse - Warehouse id
 * @param {string} params.driver_id - Driver id
 */
 export function getScanBatchReports(params) {   
    return function(dispatch) {
        dispatch({type: GET_SCAN_BATCH_REPORTS})
        return deliveryServerInstance.get(`/delivery/ext/scan/batch/reports`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: GET_SCAN_BATCH_REPORTS_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_SCAN_BATCH_REPORTS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function updateDispatchSummary(driverId, scannedNum, scannedList, timeStamp, referers) {   
    return function(dispatch) {
        dispatch({type: UPDATE_DISPATCH_SUMMARY})
        return appMainServerInstance.post(`/cargo/updatedispatchsummary`, {
            referers: referers,
            driver_id: driverId,
            start_time: timeStamp,
            end_time: timeStamp,
            total_scanned: "",
            total_unscanned: '',
            total_transfered: '0',
            total_returned: '0',
            return_orders: [],
            transfered_orders: [],
            unscanned_orders: [],
            total_complement_scanned: scannedNum,
            total_scanned_ids: scannedList
        })
        .then(({data}) => {
            dispatch({
                type: UPDATE_DISPATCH_SUMMARY_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: UPDATE_DISPATCH_SUMMARY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getOrdersByDriverCriteria(params) {   
    return function(dispatch) {
        dispatch({type: GET_ORDERS_BY_DRIVER_CRITERIA})
        return deliveryServerInstance.get(`/delivery/ext/scan/batch/parcels`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: GET_ORDERS_BY_DRIVER_CRITERIA_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_ORDERS_BY_DRIVER_CRITERIA_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.warehouse - Warehouse id
 * @param {string} params.start_date - Start date
 * @param {string} params.end_date - End date
 * @param {string} params.driver_id - Driver id
 */
export function getDispatchListHistory(params) {   
    return function(dispatch) {
        dispatch({type: GET_DISPATCH_LIST_HISTORY})
        return deliveryServerInstance.get(`/delivery/scan-summaries`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: GET_DISPATCH_LIST_HISTORY_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_DISPATCH_LIST_HISTORY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getDriverDropoffHistory(params) {   
    return function(dispatch) {
        dispatch({type: GET_DRIVER_DROPOFF_HISTORY})
        return adminServerInstance.get(`/business/getdriverdropoffhistory`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: GET_DRIVER_DROPOFF_HISTORY_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_DRIVER_DROPOFF_HISTORY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getLetianStaff(city) {   
    return function(dispatch) {
        dispatch({type: GET_LETIAN_STAFF})
        return adminServerInstance.get(`/business/getletianstaff?city=${city}`)
        .then(({data}) => {
            dispatch({
                type: GET_LETIAN_STAFF_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_LETIAN_STAFF_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getDriverDispatchBetween(params) {   
    return function(dispatch) {
        dispatch({type: GET_DRIVER_DISPATCH_BETWEEN})
        return adminServerInstance.get(`/business/getdriverdispatchbetween`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: GET_DRIVER_DISPATCH_BETWEEN_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_DRIVER_DISPATCH_BETWEEN_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getDriverDispatchById(dispatch_no) {   
    return function(dispatch) {
        dispatch({type: GET_DRIVER_DISPATCH_BY_ID})
        return adminServerInstance.get(`/business/getdriverdispatchbyid?dispatch_no=${dispatch_no}`)
        .then(({data}) => {
            dispatch({
                type: GET_DRIVER_DISPATCH_BY_ID_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_DRIVER_DISPATCH_BY_ID_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.tnos 
 * @param {string} params.driver_id
 * @param {string} params.operator
 */
export function quickTransferOrders(params) {   
    return function(dispatch) {
        dispatch({type: QUICK_TRANSFER_ORDERS})
        return adminServerInstance.post(`/business/quicktransferorders`, params)
        .then(({data}) => {
            dispatch({
                type: QUICK_TRANSFER_ORDERS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: QUICK_TRANSFER_ORDERS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}